const getters = {
    reportDataChange: (state) => state.user.reportDataChange,
    reportAllLoad: (state) => state.user.reportAllLoad,
    merchantId: (state) => state.user.merchantId,
    uid: (state) => state.user.uid
};
export default getters;
